import{createContext}from'react';var AuthContext=/*#__PURE__*/createContext({});export{AuthContext as default};